<template>
  <div class="container">
    <div class="flex items-center justify-center">
      <div class="w-full lg:w-3/5">
        <div class="text-center uppercase text-title font-semibold">
          Sign Up
        </div>
        <div class="pt-10">
          <form
            class="space-y-10 text-content"
            ref="authForm"
            @submit.stop="submit"
          >
            <div :class="{ error: v$.form.email.$errors.length }">
              <label for="">Email</label>
              <input
                type="text"
                ref="email"
                v-model="v$.form.email.$model"
                class="w-full px-0 pt-0 border-b-2 border-grey-400 n3-bg-grey outline-none opacity-50 focus:border-n3yellow"
              />
              <div
                class="input-errors"
                v-for="(error, index) of v$.form.email.$errors"
                :key="index"
              >
                <div class="error-msg">{{ error.$message }}</div>
              </div>
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 p-1 gap-10">
              <div :class="{ error: v$.form.firstName.$errors.length }">
                <label for="">First Name</label>
                <input
                  type="text"
                  v-model="v$.form.firstName.$model"
                  class="w-full px-0 pt-0 border-b-2 border-grey-400 n3-bg-grey outline-none opacity-50 focus:border-n3yellow"
                />
                <div
                  class="input-errors"
                  v-for="(error, index) of v$.form.firstName.$errors"
                  :key="index"
                >
                  <div class="error-msg">{{ error.$message }}</div>
                </div>
              </div>
              <div :class="{ error: v$.form.lastName.$errors.length }">
                <label for="">Last Name</label>
                <input
                  type="text"
                  v-model="v$.form.lastName.$model"
                  class="w-full px-0 pt-0 border-b-2 border-grey-400 n3-bg-grey outline-none opacity-50 focus:border-n3yellow"
                />
                <div
                  class="input-errors"
                  v-for="(error, index) of v$.form.lastName.$errors"
                  :key="index"
                >
                  <div class="error-msg">{{ error.$message }}</div>
                </div>
              </div>
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 p-1 gap-10">
              <div :class="{ error: v$.form.phone.$errors.length }">
                <label for="">Phone</label>
                <input
                  type="text"
                  ref="phone"
                  v-model="v$.form.phone.$model"
                  class="w-full px-0 pt-0 border-b-2 border-grey-400 n3-bg-grey outline-none opacity-50 focus:border-n3yellow"
                />
                <div
                  class="input-errors"
                  v-for="(error, index) of v$.form.phone.$errors"
                  :key="index"
                >
                  <div class="error-msg">{{ error.$message }}</div>
                </div>
              </div>

              <div :class="{ error: v$.form.city.$errors.length }">
                <label for="">City</label>
                <input
                  type="text"
                  ref="city"
                  v-model="v$.form.city.$model"
                  class="w-full px-0 pt-0 border-b-2 border-grey-400 n3-bg-grey outline-none opacity-50 focus:border-n3yellow"
                />
                <div
                  class="input-errors"
                  v-for="(error, index) of v$.form.city.$errors"
                  :key="index"
                >
                  <div class="error-msg">{{ error.$message }}</div>
                </div>
              </div>
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-2 p-1 gap-10">
              <div :class="{ error: v$.form.password.$errors.length }">
                <label for="">Password</label>
                <input
                  type="password"
                  ref="password"
                  v-model="v$.form.password.$model"
                  class="w-full px-0 pt-0 border-b-2 border-grey-400 n3-bg-grey outline-none opacity-50 focus:border-n3yellow"
                />
                <div
                  class="input-errors"
                  v-for="(error, index) of v$.form.password.$errors"
                  :key="index"
                >
                  <div class="error-msg">{{ error.$message }}</div>
                </div>
              </div>

              <div :class="{ error: v$.form.confirmPassword.$errors.length }">
                <label for="">Confirm Password</label>
                <input
                  type="password"
                  ref="confirmPassword"
                  v-model="v$.form.confirmPassword.$model"
                  class="w-full px-0 pt-0 border-b-2 border-grey-400 n3-bg-grey outline-none opacity-50 focus:border-n3yellow"
                />
                <div
                  class="input-errors"
                  v-for="(error, index) of v$.form.confirmPassword.$errors"
                  :key="index"
                >
                  <div class="error-msg">{{ error.$message }}</div>
                </div>
              </div>
            </div>

            <div class="text-center pt-5">
              <default-button
                :disable="processing || v$.form.$invalid"
                :loading="processing"
                :label="processing ? 'Loading...' : 'Sign Up'"
                classes="px-[8rem]"
                @clicked="submit"
              />

              <div class="my-10">
                Already have an account?
                <a
                  href="javascript:void(0)"
                  class="text-n3yellow"
                  @click.prevent="$router.push({ name: 'login' })"
                >
                  Sign in
                </a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DefaultButton from "@/components/button/DefaultButton.vue";
import { mapActions, mapGetters } from "vuex";
import useVuelidate from "@vuelidate/core";
import {
  required,
  email,
  minLength,
  sameAs,
  helpers,
} from "@vuelidate/validators";
import { getStorage, removeStorage } from "@/utils/helper";
import { useMeta } from "vue-meta";
import { useSweetAlert } from "@/composable/useSweetAlert";
export default {
  components: { DefaultButton },
  name: "SignUp",
  setup() {
    useMeta({ title: "Sign Up" });
    return { v$: useVuelidate() };
  },
  data: function () {
    return {
      form: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        city: "",
        password: "",
        confirmPassword: "",
      },
      passwordFieldType: "password",
      visibility: false,
      visibilityIcon: "visibility",
    };
  },
  validations() {
    return {
      form: {
        firstName: { required },
        lastName: { required },
        phone: { required },
        city: { required },
        email: {
          required,
          email,
        },
        password: {
          required,
          min: minLength(6),
        },
        confirmPassword: {
          sameAs: helpers.withMessage(
            "Password does not match",
            sameAs(this.form.password)
          ),
        },
      },
    };
  },

  computed: {
    ...mapGetters("auth", ["currentUser", "processing", "loginError"]),
    ...mapGetters("form", ["$errors"]),
  },
  watch: {
    currentUser(val) {
      if (val && val.uid) {
        setTimeout(() => {
          const lastRequested = getStorage("REDIRECT_TO") || "/";
          removeStorage("REDIRECT_TO");
          this.$router.push(lastRequested);
        }, 200);
      }
    },
  },
  methods: {
    ...mapActions("auth", ["register"]),

    submit() {
      const { Toast } = useSweetAlert();

      this.register(this.form).catch((msg) => {
        Toast.fire({
          title: msg,
          icon: "warning",
        });
      });
    },
  },
};
</script>
